export default {
    name: "independent-user-profile",
    path: "independent-user-profile/",
    component: () => import(/* webpackChunkName: "app-components-entry" */ '@/components/UserProfile/user-profile.vue')
}